import { DatePickerInput } from '@mantine/dates';
import { IconCalendar } from '@tabler/icons-react';
import dayjs from 'dayjs';
import { FC, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ngpAssignmentConfig } from '../../lib/assignment-context';
import { SamplingAssignmentMapPage } from '../gp-assignment-map/page';

export const NgpAssignmentMapPage: FC = () => {
  const { t } = useTranslation();
  const [referenceDate, setReferenceDate] = useState<Date | null>(() => new Date());

  const referenceDateParam = useMemo(
    () => (referenceDate ? dayjs(referenceDate).format('YYYY-MM-DD') : undefined),
    [referenceDate],
  );

  const yearStart = useMemo(() => dayjs().startOf('year').toDate(), []);

  return (
    <SamplingAssignmentMapPage
      config={ngpAssignmentConfig()}
      headerExtra={
        <DatePickerInput
          label={t('ngpAssignment.timeline.label')}
          leftSection={<IconCalendar size={16} />}
          maxDate={new Date()}
          minDate={yearStart}
          onChange={setReferenceDate}
          value={referenceDate}
        />
      }
      referenceDate={referenceDateParam}
    />
  );
};
